import { render, staticRenderFns } from "./RepasseApuracao.vue?vue&type=template&id=5b6deb28&"
import script from "./RepasseApuracao.vue?vue&type=script&lang=js&"
export * from "./RepasseApuracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports